import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../services/api';

export default function Track() {
  const { trackingNumber: paramTracking } = useParams();
  const [tracking, setTracking] = useState(paramTracking || '');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  const lookup = async (t) => {
    setError(''); setData(null);
    try {
      const res = await api.get(`/parcels/track/${t}`);
      setData(res.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Not found');
    }
  };

  useEffect(() => { if (paramTracking) lookup(paramTracking); }, [paramTracking]);

  return (
    <div className="container">
      <div className="card">
        <h2>Track your parcel</h2>
        <input className="input" placeholder="SDX-2026-000001" value={tracking} onChange={e => setTracking(e.target.value.toUpperCase())} />
        <button className="btn btn-primary" onClick={() => lookup(tracking)}>Track</button>
        {error && <p style={{ color: '#dc2626', marginTop: 12 }}>{error}</p>}
      </div>
      {data && (
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
            <div>
              <div className="label">Tracking</div>
              <strong>{data.parcel.tracking_number}</strong>
            </div>
            <div>
              <div className="label">Status</div>
              <strong style={{ color: '#dc2626', textTransform: 'uppercase' }}>{data.parcel.status.replace(/_/g, ' ')}</strong>
            </div>
          </div>
          <p style={{ color: '#6b7280', margin: 0 }}>{data.parcel.description}</p>
          <div style={{ marginTop: 16 }}>
            <div className="label">Timeline</div>
            {(data.events || []).map((e, i) => (
              <div key={i} style={{ padding: '8px 0', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between' }}>
                <span>{e.to_status.replace(/_/g, ' ')}</span>
                <span style={{ color: '#6b7280', fontSize: 12 }}>{new Date(e.occurred_at).toLocaleString()}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
